import TextMeApp from '@/common/TextMeApp';
import Button from '@/components/Button';
import WelcomeBanner from '@/components/WelcomeBanner';
import withOptionalAuth from '@/components/withOptionalAuth';
import MainLayout from '@/layouts/MainLayout';
import Head from 'next/head';
import Image from 'next/image';
import { NextPageWithLayout } from './_app.page';
import { useAuthUser } from '@/hooks/useAuthUser';
import { firebaseAuth } from '@/lib/Firebase';
import LandingPage from './_components/LandingPage';

function IndexPage() {
  return (
    <div className="py-6">
      <div className="flex flex-col max-w-screen-lg lg:mx-auto">
        <Head>
          <title>Welcome Bloom</title>
        </Head>

        <LandingPage />
      </div>
    </div>
  );
}

const IndexPageOptionalAuth = withOptionalAuth(IndexPage) as NextPageWithLayout;

export default IndexPageOptionalAuth;

IndexPageOptionalAuth.getLayout = MainLayout;
